import React from 'react';
import Context from './context';
import Title from './Title';
import MapImage from '../../../images/features/jtb/map.png';
import ProductMark from './ProductMark';
import Place from './Place';
import OsakiImage from '../../../images/features/jtb/osaki.png';
import AppTypography from '../../core/Typography/AppTypography';
import Box from '@material-ui/core/Box';
import HighlightImage from '../../../images/features/jtb/highlight.png';
import { OSAKI } from './variables';

const Area = () => {
  const { classes } = React.useContext(Context);

  return (
    <div>
      <Title>連携している産地</Title>
      <div className={classes.areaMapBox}>
        <img src={MapImage} className="map" />
        <Place
          link={OSAKI}
          value="鹿児島県"
          src={OsakiImage}
          classes={{ root: classes.areaOsaki }}
          top={74}
          right={20}
          width={24}
          height={182}
          border={['right', 'bottom']}
        />
        <ProductMark classes={{ root: classes.areaProduct }} />
      </div>
      <div className={classes.areaDivider} />
      <AppTypography
        size={24}
        weight="bold"
        align="center"
        mt={6}
        mb={2.5}
        color="props.palette.secondary.main"
      >
        鹿児島県 大崎町
      </AppTypography>
      <Box
        display="flex"
        alignItems="center"
        flexDirection={{ xs: 'column', sm: 'row' }}
        className={classes.areaIntro}
      >
        <div className={classes.highlight}>
          <AppTypography
            size={18}
            weight="bold"
            width={{ xs: '100%', sm: 145 }}
            color="palette.text.primary"
          >
            <Box component="span" display={{ xs: 'inline', sm: 'block' }}>
              この地域の
            </Box>
            <span>ココがおすすめ！</span>
          </AppTypography>
          <img src={HighlightImage} className="highlight" />
        </div>
        <AppTypography
          lineHeight={1.8}
          mt={{ xs: 2, sm: 0 }}
          color="palette.text.primary"
        >
          とにかくアツい！事業者が勢ぞろい。大崎町は黒牛、黒豚、うなぎ、マンゴー等々、食に関する特産品が大変多く、それらを生産する方々も並々ならぬ熱量を持っています。その熱は、事業者主体で「大崎町ふるさと特産品事業協同組合」という団体を立ち上げ、業種の壁を越えた特産品の開発、発信を行うに至っています。
        </AppTypography>
      </Box>
    </div>
  );
};

export default Area;
